// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"az_UUc","title":"az_VUc","text":"az_WUc","ymmePadding":"az_XUc"};